<!-- eslint-disable vue/no-mutating-props -->
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <v-dialog
        class="modal"
        max-width="750"
        v-model="dialog"
        content-class="sc-modal sc-modal--lg"
        scrollable
      >
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box card-action-box--edit" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" role="button" aria-label="Editar">
            <v-icon>mdi-pencil</v-icon>
          </div>
        </template>
        <span>Editar</span>
      </v-tooltip>
        </template>

        <v-card v-if="dialog" flat class="sc-modal__card">
          <!-- Close button -->
          <v-btn icon class="sc-modal__close" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <!-- Hero Header -->
          <div class="hero-header">
            <div v-if="noticiaData.url_capa" class="hero-cover">
              <v-img :src="noticiaData.url_capa" alt="Capa" height="100%" />
            </div>
            <div v-else class="hero-cover hero-cover--empty">
              <v-icon size="40" color="text_secondary">mdi-newspaper-variant-outline</v-icon>
            </div>

            <div class="hero-content">
              <div class="inline-edit-container">
                <transition name="edit-transition" mode="out-in" @after-enter="onTitleTransitionComplete">
                  <div
                    v-if="!isEditingTitle"
                    key="display"
                    class="title-display"
                    @click="startEditingTitle"
                  >
                    <h2 class="hero-title">{{ modalData.dsc_titulo_resumido }}</h2>
                    <v-icon small class="edit-icon">mdi-pencil</v-icon>
                  </div>
                  <div v-else key="edit" class="title-edit">
                    <div class="title-input-wrapper">
                      <textarea
                        ref="titleInput"
                        v-model="modalData.dsc_titulo_resumido"
                        class="title-input"
                        rows="3"
                        placeholder="Título resumido"
                        @keydown.enter.prevent="finishEditingTitle"
                        @keydown.esc="cancelEditingTitle"
                        @blur="onTitleBlur"
                      />
                      <div class="title-input-border"></div>
                    </div>
                  </div>
                </transition>
              </div>

              <div class="hero-meta-row">
                <span class="hero-meta-chip">
                  <v-icon x-small>mdi-web</v-icon>
                  {{ portalDisplayName(noticiaData.cod_portal) }}
                </span>
                <span v-if="noticiaData.dat_modificacao_noticia" class="hero-meta-chip">
                  <v-icon x-small>mdi-clock-outline</v-icon>
                  {{ formatDate(noticiaData.dat_modificacao_noticia) }} · {{ formatHour(noticiaData.dat_modificacao_noticia) }}
                </span>
              </div>

              <span class="hero-warning">
                Somente o título resumido pode ser editado para manter a integridade da notícia.
              </span>
            </div>
          </div>

          <!-- Subtitle (read-only) -->
          <div v-if="noticiaData.dsc_subtitulo" class="edit-section">
            <div class="section-header">
              <v-icon small class="mr-2">mdi-text</v-icon>
              <span>Subtítulo</span>
            </div>
            <p class="noticia-subtitle-text">{{ noticiaData.dsc_subtitulo }}</p>
          </div>

          <!-- Footer -->
          <div class="sc-modal__footer">
            <v-btn text class="modal-btn-cancel" @click="dialog = false">Cancelar</v-btn>
            <v-btn color="primary" class="modal-btn-confirm" @click.prevent="alterarNoticia">Salvar</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </transition>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import { formatDate, formatHour } from "@/utils/dateUtils";

export default {
  data() {
    return {
      dialog: false,
      isEditingTitle: false,
      originalTitle: "",
      modalData: {
        dsc_titulo_resumido: this.noticiaData.dsc_titulo_resumido,
      },
    };
  },
  props: {
    cod_noticia: { type: [Number, String] },
    noticiaData: Object,
    cod_pasta: Number,
  },
  computed: {
    ...mapGetters({
      portalDisplayName: "portais/getPortalDisplayName",
    }),
  },
  methods: {
    ...mapActions({
      getNoticiasAprovadas: "noticias/getNoticiasAprovadas",
      getNoticiasModeradas: "noticias/getNoticiasModeradas",
    }),
    formatDate,
    formatHour,
    startEditingTitle() {
      this.originalTitle = this.modalData.dsc_titulo_resumido;
      this.isEditingTitle = true;
    },
    onTitleTransitionComplete() {
      if (this.isEditingTitle && this.$refs.titleInput) {
        this.$refs.titleInput.focus();
      }
    },
    finishEditingTitle() {
      if (this.modalData.dsc_titulo_resumido.trim() === "") {
        this.modalData.dsc_titulo_resumido = this.originalTitle;
      }
      this.isEditingTitle = false;
    },
    cancelEditingTitle() {
      this.modalData.dsc_titulo_resumido = this.originalTitle;
      this.isEditingTitle = false;
    },
    onTitleBlur() {
      setTimeout(() => {
        if (this.isEditingTitle) {
          this.finishEditingTitle();
        }
      }, 150);
    },
    async alterarNoticia() {
      await apiClient
        .patch("/noticiasModeradas/alterarNoticiaModerada", {
          cod_noticia: this.cod_noticia,
          cod_portal: this.noticiaData.cod_portal,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          dsc_titulo_resumido: this.modalData.dsc_titulo_resumido,
        })
        .then(async () => {
          this.$toast.success("Notícia atualizada com sucesso!");
          await this.getNoticiasAprovadas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.noticias.filtro_aprovadas,
            flg_favorita: this.$store.state.noticias.flg_favorita,
            size: 5,
            page: this.$store.state.noticias.noticiasAprovadas.currentPage,
            cod_pasta: this.cod_pasta,
            cod_editoria: this.$store.state.portais.selectedEditoria,
          });
          await this.getNoticiasModeradas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            page: this.$store.state.noticias.noticiasModeradas.currentPage,
            size: 5,
            filtro_texto: this.$store.state.noticias.filtro_moderadas,
          });
          this.dialog = false;
        })
        .catch((error) => {
          const msg = error.response?.data?.error || "Erro ao atualizar notícia";
          this.$toast.error(msg);
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// Modal shell (card, close, footer) comes from _modal.scss (sc-modal__*).
// This block only carries this hero modal's component-specific pieces:
// hero-header layout, inline title editor, and the read-only subtitle section.

/* Hero Header */
.hero-header {
  display: flex;
  gap: 20px;
  padding: 24px;
  background: linear-gradient(135deg, var(--v-surface_tertiary-base) 0%, var(--v-surface_secondary-base) 100%);
  border-bottom: 1px solid var(--sc-border-subtle);
}

.hero-cover {
  flex-shrink: 0;
  width: 160px;
  height: 120px;
  border-radius: var(--sc-radius-md);
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);

  &--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--v-surface_tertiary-base);
    border: 1px dashed var(--sc-border-default);
  }
}

.hero-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding-right: 40px;
}

.hero-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.hero-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  color: var(--v-text_secondary-base);
  background: var(--sc-surface-tint-hover);
  padding: 3px 8px;
  border-radius: var(--sc-radius-sm);
  border: 1px solid var(--sc-border-subtle);

  .v-icon { opacity: 0.6; }
}

.hero-warning {
  font-size: 0.75rem;
  font-weight: 500;
  color: #F44336;
  display: flex;
  align-items: center;
}

/* Inline title editor */
.inline-edit-container {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  margin-bottom: 8px;
}

.title-display {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: var(--sc-radius-md);
  transition: all 0.25s var(--sc-easing-standard);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: var(--sc-radius-md);
    background: rgba(255, 255, 255, 0);
    transition: background 0.25s var(--sc-easing-standard);
  }

  &:hover {
    &::before { background: var(--sc-surface-tint-hover); }
    .edit-icon { opacity: 0.8; transform: scale(1); }
  }

  &:active { transform: scale(0.98); }
}

.hero-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--v-text_primary-base);
  margin: 0;
  line-height: 1.4;
  position: relative;
  z-index: 1;
}

.edit-icon {
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.25s var(--sc-easing-standard);
  color: var(--v-text_secondary-base);
  position: relative;
  z-index: 1;
  margin-top: 4px;
}

.title-edit {
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.title-input-wrapper {
  position: relative;
  width: 100%;
}

.title-input {
  background: var(--sc-surface-tint);
  border: none;
  border-radius: var(--sc-radius-md);
  padding: 8px 14px;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--v-text_primary-base);
  outline: none;
  font-family: inherit;
  position: relative;
  z-index: 1;
  width: 100%;
  resize: none;
  line-height: 1.4;
}

.title-input-border {
  position: absolute;
  inset: 0;
  border: 2px solid var(--v-primary-base);
  border-radius: var(--sc-radius-md);
  pointer-events: none;
}

/* Edit transition */
.edit-transition-enter-active {
  animation: edit-in 0.25s var(--sc-easing-standard);
}
.edit-transition-leave-active {
  animation: edit-out 0.2s var(--sc-easing-standard);
}
@keyframes edit-in {
  0% { opacity: 0; transform: translateY(-8px) scale(0.96); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes edit-out {
  0% { opacity: 1; transform: translateY(0) scale(1); }
  100% { opacity: 0; transform: translateY(8px) scale(0.96); }
}

.edit-section {
  padding: 16px 24px 0;
}

.noticia-subtitle-text {
  font-size: 0.9rem;
  color: var(--v-text_secondary-base);
  line-height: 1.5;
  margin: 0;
  padding: 12px;
  background: var(--sc-surface-tint);
  border-radius: var(--sc-radius-md);
  border: 1px solid var(--sc-border-subtle);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Edit transition */
.edit-transition-enter-active { transition: opacity var(--sc-duration-fast) var(--sc-easing-standard); }
.edit-transition-leave-active { transition: opacity 0.1s ease; }
.edit-transition-enter, .edit-transition-leave-to { opacity: 0; }

/* Modal fade */
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.3s ease; }
</style>
